import { createAuctionHouseBuilder } from './operations/createAuctionHouse.mjs';
import { createBidBuilder } from './operations/createBid.mjs';
import { createListingBuilder } from './operations/createListing.mjs';
import { executeSaleBuilder } from './operations/executeSale.mjs';
import { updateAuctionHouseBuilder } from './operations/updateAuctionHouse.mjs';
import { directBuyBuilder } from './operations/directBuy.mjs';
import { cancelBidBuilder } from './operations/cancelBid.mjs';
import { cancelListingBuilder } from './operations/cancelListing.mjs';
import { depositToBuyerAccountBuilder } from './operations/depositToBuyerAccount.mjs';
import { directSellBuilder } from './operations/directSell.mjs';
import { withdrawFromBuyerAccountBuilder } from './operations/withdrawFromBuyerAccount.mjs';

/**
 * This client allows you to access the underlying Transaction Builders
 * for the write operations of the Auction House module.
 *
 * @see {@link AuctionsClient}
 * @group Module Builders
 * */
class AuctionHouseBuildersClient {
  constructor(metaplex) {
    this.metaplex = metaplex;
  }

  /** {@inheritDoc createBidBuilder} */
  bid(input, options) {
    return createBidBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc directBuyBuilder} */
  buy(input, options) {
    return directBuyBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc cancelBidBuilder} */
  cancelBid(input, options) {
    return cancelBidBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc cancelListingBuilder} */
  cancelListing(input, options) {
    return cancelListingBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createAuctionHouseBuilder} */
  createAuctionHouse(input, options) {
    return createAuctionHouseBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc depositToBuyerAccountBuilder} */
  depositToBuyerAccount(input, options) {
    return depositToBuyerAccountBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc executeSaleBuilder} */
  executeSale(input, options) {
    return executeSaleBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc createListingBuilder} */
  list(input, options) {
    return createListingBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc directSellBuilder} */
  sell(input, options) {
    return directSellBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc updateAuctionHouseBuilder} */
  updateAuctionHouse(input, options) {
    return updateAuctionHouseBuilder(this.metaplex, input, options);
  }

  /** {@inheritDoc withdrawFromBuyerAccountBuilder} */
  withdrawFromBuyerAccount(input, options) {
    return withdrawFromBuyerAccountBuilder(this.metaplex, input, options);
  }
}

export { AuctionHouseBuildersClient };
//# sourceMappingURL=AuctionHouseBuildersClient.mjs.map
